///防抖
let timeout, result;
const debouce = function(func) {
	let args = arguments;
	// console.log(args);
	if (timeout) {
		clearTimeout(timeout)
	}
	let callNow = !timeout
	timeout = setTimeout(() => {
		timeout = null;
	}, 1000)
	if (callNow) {
		result = func.apply(this, args) //如this指向有问题再开启 并注释下一行
		// result = func(...args)
	}
	return result
}
///节流
var timer;
const throttle = function(func, wait) {
	return function() {
		let context = this;
		let args = arguments;
		if (!timer) {
			timer = setTimeout(() => {
				timer = null;
				func.apply(context, args)
			}, wait)
		}
	}
} 

export default {
	debouce,
	throttle
}



// WEBPACK FOOTER //
// ./src/util/debouce.js